/* DEPRECATED
   use graphQL instead
*/
import { AxiosInstance } from 'axios'

// TODO: check if this file is still used convert it to graphQL and remove if not.

export default (axios: AxiosInstance) => {
  return {
    delete(workspaceId: number, serieId: number) {
      return axios
        .delete<{ msg: string }>(`/workspaces/${workspaceId}/series/${serieId}`)
        .then((res) => res.data)
    },
    create(workspaceId: number, title: string) {
      return axios
        .post(`/workspaces/${workspaceId}/series`, { title })
        .then((res) => res.data)
    },
    patch(workspaceId: number, serieId: number, data: { title?: string }) {
      return axios
        .patch(`/workspaces/${workspaceId}/series/${serieId}`, data)
        .then((res) => res.data)
    },
    addToTopicToSeries(seriesId: number, topicId: number, workspaceId: number) {
      return axios
        .post(`/series/addTopic/seriesId/${seriesId}`, {
          topicId,
          workspaceId
        })
        .then((res) => res.data)
    }
  }
}
